const prefix = 'LEADS_SETTINGS';

// fetch, create, update, delete custom statuses.
export const GET_LEADS_STATUSES = Symbol(`${prefix}/GET_LEADS_STATUSES`);
export const GET_LEADS_STATUSES_SUCCESS = Symbol(`${prefix}/GET_LEADS_STATUSES_SUCCESS`);
export const CREATE_LEADS_STATUS = Symbol(`${prefix}/CREATE_LEADS_STATUS`);
export const UPDATE_CUSTOM_STATUS = Symbol(`${prefix}/UPDATE_CUSTOM_STATUS`);
export const DELETE_CUSTOM_STATUS = Symbol(`${prefix}/DELETE_CUSTOM_STATUS`);
export const UPDATE_STATUSES_SUCCESS = Symbol(`${prefix}/UPDATE_STATUSES_SUCCESS`);
export const UPDATE_STATUSES_FAIL = Symbol(`${prefix}/UPDATE_STATUSES_FAIL`);

// Reorder statuses
export const REORDER_LEADS_STATUSES = Symbol(`${prefix}/REORDER_LEADS_STATUSES`);
export const REORDER_LEADS_STATUSES_SUCCESS = Symbol(`${prefix}/REORDER_LEADS_STATUSES_SUCCESS`);
export const REORDER_LEADS_STATUSES_FAIL = Symbol(`${prefix}/REORDER_LEADS_STATUSES_FAIL`);

// default assignments
export const GET_DEFAULT_ASSIGNMENTS = Symbol(`${prefix}/GET_DEFAULT_ASSIGNMENTS`);
export const SET_DEFAULT_ASSIGNMENT = Symbol(`${prefix}/SET_DEFAULT_ASSIGNMENT`);
export const UNSET_DEFAULT_ASSIGNMENT = Symbol(`${prefix}/UNSET_DEFAULT_ASSIGNMENT`);
export const UPDATE_DEFAULT_ASSIGNMENTS_SUCCESS = Symbol(`${prefix}/UPDATE_DEFAULT_ASSIGNMENTS_SUCCESS`);
export const UPDATE_DEFAULT_ASSIGNMENTS_FAIL = Symbol(`${prefix}/UPDATE_DEFAULT_ASSIGNMENTS_FAIL`);

// incoming notifications
export const GET_INCOMING_NOTIFICATION_USERS = Symbol(`${prefix}/GET_INCOMING_NOTIFICATION_USERS`);
export const ADD_LEAD_CONTACT = Symbol(`${prefix}/ADD_LEAD_CONTACT`);
export const DELETE_LEAD_CONTACT = Symbol(`${prefix}/DELETE_LEAD_CONTACT`);
export const UPDATE_INCOMING_NOTIFICATION_SUCCESS = Symbol(`${prefix}/UPDATE_INCOMING_NOTIFICATION_SUCCESS`);
export const UPDATE_INCOMING_NOTIFICATION_FAIL = Symbol(`${prefix}/UPDATE_INCOMING_NOTIFICATION_FAIL`);

export const GET_LEAD_CHECKLIST_TEMPLATES = Symbol(`${prefix}/GET_LEAD_CHECKLIST_TEMPLATES`);
export const ADD_LEAD_CHECKLIST_TEMPLATES = Symbol(`${prefix}/ADD_LEAD_CHECKLIST_TEMPLATES`);
